import CollapsingText from './CollapsingText';

export default CollapsingText;
